import React from "react";
import { Form } from "react-bootstrap";

const TextAreaInputFormik = ({ formik, field, maxLength, type, rows, disabled }) => (
  <>
    <Form.Control
      as="textarea"
      rows={rows}
      style={{ width: "100%" }}
      id={field}
      name={field}
      maxLength={maxLength}
      type={type}
      disabled={formik.isSubmitting || disabled}
      value={formik.values[field]}
      onChange={formik.handleChange}
      isInvalid={formik.touched[field] && formik.errors[field]}
    />
    {formik.touched[field] && formik.errors[field] && (
      <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>
    )}
  </>
);

export default TextAreaInputFormik;
